import { useEffect, useState } from "react";

/**
 * useDebouncedValue — retourne une version « debouncée » de `value` qui
 * ne se met à jour qu'après `delay` ms sans nouveau changement. Sert de
 * source pour les fetches serveur (recherche, filtres) afin d'éviter
 * un appel réseau par frappe clavier.
 *
 * Spec rev163 (2026-02) — utilisé par Documents / Tâches / AVI pour
 * unifier le comportement debounce + liseré animé.
 */
export default function useDebouncedValue(value, delay = 250) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}
